<!--
	用法:
        this.$store.commit('showLoading', true);

 -->

<template>
  <div class="loading" :style="{width: width, height: height}">
    <div class="loading-layer" :style="{width: width, height: height}"></div>
    <img src="../../assets/images/common/data-loading.gif">
   </div>
</template>

<script>
  import $ from 'jquery'
  export default{
    data(){
      return{
        width: 0,
        height: 0
      }
    },
    mounted(){
      this.width = $(window).width() + 'px';
      this.height = $(window).height() + 'px';
    }
  }
</script>

<style>
  .loading-layer{
    /*height: 100%;*/
    /*width: 100%;*/
  }
  .loading{
    height: 100%;
    position: fixed;
    top:0;
    z-index: 97;
    border-radius: 0!important;
    background-color:rgba(0,0,0,0)!important;
    padding:0!important;
  }
  .loading .loading-layer{
    background-color: rgba(0,0,0,0.2);
  }
  .loading img{
    position: absolute;
    left:0;
    top:0;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: 101;
  }
</style>
